import { Receipt } from "lucide-react";

const plansHeading = (isRecurring, sub) => {
  if (isRecurring) return "Change plan";
  return sub.cycle === "trial" ? "Subscribe to continue" : "Choose a plan";
};
const planButtonLabel = ({ current, isRecurring, down, sameCode, cycle }) => {
  if (current) return "Current plan";
  if (!isRecurring) return "Subscribe";
  if (down) return "Downgrade";
  return sameCode ? `Switch to ${cycle}` : "Upgrade";
};

// Plan picker, one-time purchases and invoice list (admins only).
export function PlanCatalog({ sub, usage, settings, subs, oneTime, invoices, isRecurring, cycle, setCycle, busy, setDlg, checkout }) {
  const rank = (c) => subs.findIndex((p) => p.code === c);
  return (
    <>
          <div className="flex items-center justify-between mb-3" id="plans">
            <div className="label-cap">{plansHeading(isRecurring, sub)}</div>
            <div className="inline-flex bg-slate-900 border border-slate-800 rounded-full p-0.5 text-xs">
              <button onClick={() => setCycle("monthly")} className={`px-3 py-1 rounded-full ${cycle === "monthly" ? "bg-amber-500 text-slate-950 font-semibold" : "text-slate-400"}`} data-testid="billing-cycle-monthly">Monthly</button>
              <button onClick={() => setCycle("annual")} className={`px-3 py-1 rounded-full ${cycle === "annual" ? "bg-amber-500 text-slate-950 font-semibold" : "text-slate-400"}`} data-testid="billing-cycle-annual">Annual · {settings.annual_note}</button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
            {subs.map((p) => {
              const current = sub.plan_code === p.code && sub.cycle === cycle && sub.status !== "none";
              const down = isRecurring && rank(p.code) < rank(sub.plan_code);
              return (
                <div key={p.code} className={`sc-card p-4 ${current ? "border-amber-500/60" : ""}`} data-testid={`billing-plan-${p.code}`}>
                  <div className="font-heading font-bold text-slate-100">{p.name} {p.featured && <span className="text-[10px] text-amber-400 ml-1">RECOMMENDED</span>}</div>
                  <div className="font-heading text-2xl font-extrabold mt-1">${(cycle === "annual" ? p.price_annual : p.price_monthly).toLocaleString()}<span className="text-xs text-slate-400">/{cycle === "annual" ? "yr" : "mo"}</span></div>
                  <div className="text-xs text-slate-500 font-mono">{p.limits.users} users · {p.limits.active_projects} projects · {p.limits.ai_reviews_per_month} reviews/mo</div>
                  <button disabled={busy || current || sub.status === "paused"} onClick={() => isRecurring ? setDlg({ type: down ? "downgrade" : "change", plan: p }) : checkout(p.code, cycle)}
                    className="mt-3 w-full text-sm font-semibold py-2 rounded-md bg-amber-500 hover:bg-amber-400 text-slate-950 disabled:opacity-40" data-testid={`select-plan-${p.code}`}>
                    {planButtonLabel({ current, isRecurring, down, sameCode: sub.plan_code === p.code, cycle })}
                  </button>
                </div>
              );
            })}
          </div>
          {!isRecurring && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
              {oneTime.map((p) => (
                <div key={p.code} className="sc-card p-4 flex items-center justify-between" data-testid={`billing-plan-${p.code}`}>
                  <div><div className="font-heading font-bold text-slate-100">{p.name}</div><div className="text-xs text-slate-500">${p.one_time_price} one-time · {p.access_days} days · 1 project</div></div>
                  <button disabled={busy} onClick={() => checkout(p.code, "once")} className="border border-slate-700 hover:border-amber-500 px-3 py-2 rounded-md text-sm" data-testid={`select-plan-${p.code}`}>Buy</button>
                </div>
              ))}
            </div>
          )}
          <div className="sc-card p-5" data-testid="invoices-card">
            <div className="label-cap mb-2 flex items-center gap-2"><Receipt className="w-3.5 h-3.5" /> Invoices & payments</div>
            {!invoices.length && <div className="text-xs text-slate-500">No invoices yet.</div>}
            {invoices.map((i) => (
              <div key={i.id} className="flex justify-between text-xs py-1.5 border-b border-slate-800/60 last:border-0 font-mono">
                <span className="text-slate-400">{new Date(i.created).toLocaleDateString()} · {i.number}</span><span className="text-slate-200">${Number(i.amount).toFixed(2)} <span className="text-slate-500">{i.status}</span> {i.hosted && <a href={i.hosted} target="_blank" rel="noreferrer" className="text-amber-400 ml-2">view</a>}</span>
              </div>
            ))}
          </div>
    </>
  );
}
